import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=0e9a97f6&scoped=true"
import script from "./TeacherProfile.vue?vue&type=script&lang=js"
export * from "./TeacherProfile.vue?vue&type=script&lang=js"
import style0 from "./TeacherProfile.vue?vue&type=style&index=0&id=0e9a97f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a97f6",
  null
  
)

export default component.exports